import { css } from '@emotion/react';
import { Typography } from '@mui/material';
import { Stack } from '@mui/system';
import { Markdown } from '@scorenco/components';

import { ElasticSearchProvider } from '@/components';

import { SearchClub } from './SearchClub';
import { ShapesWrapper } from './ShapesWrapper';

type SportHeroProps = {
  title?: string;
  sport: string;
  images?: ({ url?: string | null } | undefined)[];
};

export const SportHero = ({ title, sport, images }: SportHeroProps) => {
  return (
    <ShapesWrapper images={images}>
      <Stack alignItems="center" justifyContent="center" gap={4}>
        <Typography
          component="h1"
          variant="h1"
          maxWidth="md"
          align="center"
          css={(theme) => css`
            strong {
              color: ${theme.vars.palette.secondary.main};
            }
          `}
        >
          <Markdown isInline value={title} />
        </Typography>

        <ElasticSearchProvider
          defaultFilters={{ sport_slug: sport, type: 'club' }}
        >
          <SearchClub
            sport={sport}
            sx={{
              width: 'calc(100% - 2rem)',
              maxWidth: 'sm',
            }}
          />
        </ElasticSearchProvider>
      </Stack>
    </ShapesWrapper>
  );
};
